module.exports = __webpack_public_path__ + "src/img/smartEdit.32d21596.svg";